import { DEFAULT_PAGE_SIZE } from "../../../utils/contants";
const { createApi, fetchBaseQuery } = require("@reduxjs/toolkit/query/react");

export const ApiCredentials = createApi({
    reducerPath: 'apiCredentials',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        listApiKeys: builder.mutation({
            query: (payload) => ({
                url: payload?.page ? `credentials?page=${payload.page}&limit=${DEFAULT_PAGE_SIZE}` : 'credentials',
                method: 'GET'
            })
        }),
        addApiKey: builder.mutation({
            query: (payload) => ({
                url: 'credentials',
                method: 'POST',
                body: payload
            })
        }),
        manageApiKey: builder.mutation({
            query: (payload) => ({
                url: 'credentials',
                method: 'PATCH',
                body: payload
            })
        }),
        deleteApiKey: builder.mutation({
            query: (payload) => ({
                url: `credentials/${payload.id}`,
                method: 'DELETE'
            })
        })
    })
})

export const { useListApiKeysMutation, useAddApiKeyMutation, useManageApiKeyMutation, useDeleteApiKeyMutation } = ApiCredentials;